/**
 * TaxCodeLookupHint — dòng nhắc dưới ô mã số thuế.
 *
 * Luật ③ của tra cứu mã số thuế: tra không ra thì KHÔNG khoá ô, KHÔNG chặn lưu,
 * KHÔNG hiện lỗi đỏ — nên mọi câu ở đây đều là chữ xám. Chữ có màu chỉ dành cho
 * MỘT việc: nguồn nói doanh nghiệp đã ngừng hoạt động, thứ người nhập cần biết
 * trước khi xuất hóa đơn cho họ.
 *
 * "Không tìm thấy mã" và "chưa tra được" cố ý là hai câu khác nhau: câu đầu nói
 * mã sai, câu sau nói mạng hoặc nguồn chết. Gộp làm một là đổ oan cho người nhập.
 */
import type { CompanyLookup } from "@/lib/company-lookup";

export function TaxCodeLookupHint({
  lookup,
  showUse,
  onUse,
}: {
  lookup: CompanyLookup;
  showUse: boolean;
  onUse: () => void;
}) {
  if (lookup.state === "idle") return null;

  return (
    <div className="mt-1 space-y-1 text-xs leading-relaxed" aria-live="polite">
      {lookup.state === "loading" && (
        <p className="text-muted-foreground">Đang tra thông tin công ty…</p>
      )}

      {lookup.state === "not-found" && (
        <p className="text-muted-foreground">
          Không tìm thấy mã số thuế này trên hệ thống thuế — cứ nhập tay, vẫn lưu được.
        </p>
      )}

      {lookup.state === "unavailable" && (
        <p className="text-muted-foreground">
          Chưa tra được thông tin công ty — nhập tay giúp em nhé.
        </p>
      )}

      {lookup.state === "found" && (
        <>
          <p className="text-muted-foreground">
            {lookup.company.name || "Có hồ sơ trên hệ thống thuế"}
          </p>
          {lookup.company.stopped && (
            <p className="text-warning-text">Hệ thống thuế ghi: {lookup.company.statusText}</p>
          )}
          {showUse && (
            // type="button": khối này nằm TRONG form đặt lịch và form tạo đơn —
            // thiếu nó là bấm "Dùng thông tin này" lại gửi luôn cả form.
            <button
              type="button"
              onClick={onUse}
              className="text-primary underline underline-offset-4 hover:no-underline"
            >
              Dùng thông tin này
            </button>
          )}
        </>
      )}
    </div>
  );
}
